import React, { useEffect, useState, useMemo } from "react";
import styled from "styled-components";
import {
  ButtonFilled,
  ButtonOutlined,
  Buttontransparent,
} from "../../../../Reusablecomponents/UIButtons";
import { CloseOutlined, EyeOutlined, LeftOutlined } from "@ant-design/icons";
import { Tooltip, Col, Row, Tabs, Form, Spin, Upload } from "antd";
import { ReactComponent as CopyIcon } from "../../../../assets/images/Vector.svg";
import { ReactComponent as DeleteIcon } from "../../../../assets/images/delete-icon.svg";
import { ReactComponent as EditIcon } from "../../../../assets/images/Editicon.svg";
import { ReactComponent as ChatIcon } from "../../../../assets/images/Chat.svg";
import { ReactComponent as Indicator } from "../../../../assets/images/Indicator.svg";
import { ReactComponent as Send } from "../../../../assets/images/send-01-svgrepo-com.svg";
import { StyledTable } from "../../../../Reusablecomponents/UITable/UITable";
import { ReactComponent as DownloadIcon } from "../../../../assets/images/download1.svg";
import GridBuilder from "../../../../UIBuilderEngine/GridBuilder";
import ReusableDrawer from "../../../../Reusablecomponents/ReusableDrawer";
import UIModal from "../../../../Reusablecomponents/UIModal";
import dayjs from "dayjs";
import { CALL_API } from "../../../../Common/api";
import FilesTable from "../../../../Reusablecomponents/FilesTable";
import moment from "moment";
import { useSelector } from "react-redux";

const WrapperBox = styled.div`
  .consingment_container {
    display: flex;
    width: 100%;
    justify-content: space-between;
  }
  @media (min-width: 320px) and (max-width: 420px) {
    .consingment_container {
      display: flex;
      flex-direction: column;
    }
    .consingment_container_two {
      display: flex;
      gap: 10px;
    }
    .consingment_container_formbresponsive {
      display: flex;
      flex-direction: row;
      gap: 20px;
      justify-content: end;
    }

    .container_for_consignorpage {
      .consignor_code {
        width: 100% !important;
      }
    }
  }
  @media (min-width: 421px) and (max-width: 768px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 50% !important;
      }
    }
  }
  @media (min-width: 769px) and (max-width: 991px) {
    .container_for_consignorpage {
      .consignor_code {
        width: 33% !important;
      }
    }
  }

  @media (max-width: 320px) {
    .tabsectionfor_table {
      display: flex;
      flex-direction: column;
    }
  }

  .consingment_container_two {
    display: flex;
    align-items: center;
  }
  .consingment_container_record {
    display: flex;
    flex-direction: column;
    gap: 19px;
    text-align: justify;
  }
  p {
    margin-bottom: 0px;
    line-height: 0px;
    font-size: 16px;
    font-weight: 400;
  }
  .Create_btn {
    border: none;
    outline: none;
    background-color: rgb(235, 247, 237);
    color: white;
    border-radius: 50%;
    padding: 17px 13px 17px 13px;
    font-size: 16px;
  }

  .left_outlined_icon {
    color: rgb(44, 150, 61);
    transform: scale(0.8);
  }
  .Create_btn_edit {
    border-radius: 50%;
    padding: 9px;
    border: 1px solid rgb(231, 231, 237);
    display: flex;
    justify-content: center;
    align-items: center;
    background-color: rgb(235, 247, 237);
  }
  .container_for_consignorpage {
    background-color: rgb(248, 248, 248);
    border-radius: 12px;
    margin: 16px 5px 20px 5px;
    display: flex;
    width: 100%;
    padding: 10px 10px 10px 10px;
    flex-wrap: wrap;
  }
  .consignor_code {
    width: 25%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code_container {
    width: 100%;
    padding: 10px 10px 10px 10px;
    margin: 5px 0px 5px 0px;
  }
  .consignor_code > label {
    color: rgb(152, 161, 181);
    padding: 5px 0px 5px 0px;
    font-size: 14px;
  }
  .Add_btn {
    border: none;
  }
  .tabsectionfor_table {
    display: flex;
    justify-content: space-between;
  }
  .ant-tabs-tab {
    font-size: 15px !important;
    font-weight: 400 !important;
    color: #5f6d8c !important;
    border-radius: 27px !important;
  }
  .ant-tabs-tab-active .ant-tabs-tab-btn {
    color: #2c963d !important;
  }
  .ant-tabs-tab:hover {
    color: #5f6d8c !important; /* Darker green on hover */
  }
  .ant-table-tbody > tr > td > * {
    margin-left: 12px;
  }

  .consignor_tab_container.ant-tabs-top > .ant-tabs-nav::before {
    border-bottom: unset !important;
  }
  .ant-tabs > .ant-tabs-nav .ant-tabs-nav-list {
    display: flex;
    gap: 15px;
  }
  .Creating_Consignor {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 7px 7px 7px 5px;
    margin-bottom: 19px;
    border-bottom: 1px solid rgb(231 231, 237);
  }

  .resolve_btn:hover {
    background-color: green !important;
    color: white !important;
  }

  .container_for_uimodaltwo {
    background-color: rgb(241, 241, 241);
    padding: 70px 70px 70px 70px;
    border-radius: 13px;
    margin-top: 20px;
  }
  .cancel_btn_forpopup_two {
    background-color: rgb(232, 255, 236);
    color: green;
  }
`;

const FuelDetails = ({
  setConsignee,
  AddEditFormm,
  handleChange,
  handleSubmitForm,
  handleClose,
  drawerOpen,
  setDrawerOpen,
  fuelId,
  selectedFuelRecord,
  vehicleList,
  setIsEditing,
  setFormData,
  handleDelete,
}) => {
  const driverList = useSelector((state) => state?.authTracking?.driverList);
  const userInfo = useSelector((state) => state?.authTracking?.userInfo);
  const [form] = Form.useForm();
  const [activekey, setactivekey] = useState("1");
  const [hoveredrow, setHoveredrow] = useState(null);
  const [showModal, SetshowModal] = useState(false);
  const [modalType, setModalType] = useState(null);
  const [deleteConfirmOpen, setDeleteConfirmOpen] = useState(false);
  const [filesList, setFilesList] = useState([]);
  const [loading, setLoading] = useState([]);
  const [CustomData, setCustomData] = useState([]);
  const reduxPermissions = useSelector(
    (state) => state?.authTracking?.myPermissionList || {},
  );
  const hasPermission = (seccode, action) => {
    if (!seccode || !action) return false;
    const code = seccode.toUpperCase();
    const act = action.toUpperCase();
    return (
      Array.isArray(reduxPermissions?.[code]) &&
      reduxPermissions[code].includes(act)
    );
  };
  const updateAllowed = useMemo(
    () => hasPermission("FUEL", "UPF"),
    [reduxPermissions],
  );
  const deleteAllowed = useMemo(
    () => hasPermission("FUEL", "DEF"),
    [reduxPermissions],
  );
  const fUploadAllowed = useMemo(
    () => hasPermission("FUEL", "UF"),
    [reduxPermissions],
  );

  const details = selectedFuelRecord || {};

  const getcustomedatabyRefId = async () => {
    try {
      // const { data } = await CALL_API(
      //   "GET",
      //   `mastertable/GetCustomeData?RefId=${fuelId}`
      // );
      const { data } = await CALL_API("POST", `mastertable/GetByReftab`, {
        ReftableId: "Fuel",
        RefId: fuelId,
        Active: 1,
        McId: userInfo?.MCID,
      });
      if (Array.isArray(data)) {
        setCustomData(data);
      } else if (typeof data === "object" && data !== null) {
        // Wrap the single object in an array
        setCustomData([data]);
      } else {
        setCustomData([]);
        console.warn("Unexpected custom data format:", data);
      }
    } catch (error) {
      console.error("Error fetching custom data:", error);
      setCustomData([]);
    }
  };

  const getFileData = async () => {
    setLoading(true);
    const { data } = await CALL_API("POST", `trip/getFileTab`, {
      refTab: "FUEL",
      refId: fuelId,
    });
    setFilesList(data);
    setLoading(false);
  };

  const handleFileUpload = async (payload) => {
    setLoading(true);
    const { data } = await CALL_API("POST", "common/file/addFile", payload);
    setLoading(false);
    getFileData();
  };
  const handleresolveopen = () => setModalType("resolve");
  const handleudoUpdateOpen = () => setModalType("udoUpdate");

  // Common close handler
  const handleModalClose = () => setModalType(null);

  const editUser = (record) => {
    setIsEditing(true);
    setFormData(record);
    setDrawerOpen(true);
  };

  const handlechange = (key) => {
    setactivekey(key);
  };

  const handleClickme = () => {
    setConsignee(false);
  };
  const handleeditclick = () => {
    setDrawerOpen(true);
    setIsEditing(true);
    const vehId =
      details?.VEHID ||
      vehicleList?.find(
        (item) => item?.REGNO === (details?.RegNo || details?.REGNO),
      )?.VEHID;
    setFormData({
      FUELID: details?.FUELID,
      vehicle: vehId,
      price: details?.RATE,
      Milage: details?.MILAGE,
      fueldate: dayjs(details?.FUELDATE),
      odoreading: details?.ODOREADING,
      litres: details?.QTY,
      CRBY: details?.CRBY,
      CRON: details?.CRON,
      StationName: details?.StationName,
      transporter: details?.SHIPPER,
      fueltext: "",
    });
  };

  const editModuleupdate = () => {
    handleresolveopen(true);
  };

  const handleDeleteClick = () => {
    setDeleteConfirmOpen(true);
  };

  const confirmDelete = () => {
    handleDelete(details?.FUELID || fuelId);
    setDeleteConfirmOpen(false);
    setConsignee(false);
  };

  const cancelDelete = () => {
    setDeleteConfirmOpen(false);
  };

  useEffect(() => {
    getFileData();
    getcustomedatabyRefId();
  }, [fuelId]);

  return (
    <>
      <UIModal
        width={500}
        open={deleteConfirmOpen}
        onClose={cancelDelete}
        closeButton={false}
        size="md"
        header={false}
        footer={false}
      >
        <div className="text-center">
          <h1>Are you sure,</h1>
          <h6>You want to delete this?</h6>
          <div className="mt-2 w-100 d-flex justify-content-center">
            <ButtonFilled onClick={confirmDelete}>
              Yes
            </ButtonFilled>
            <Buttontransparent onClick={cancelDelete}>
              No
            </Buttontransparent>
          </div>
        </div>
      </UIModal>

      <UIModal
        width={600}
        open={modalType !== null} // Open if any modal type is set
        onClose={handleModalClose}
        closeButton={false}
        header={
          <WrapperBox>
            <Row>
              <Col xl={24} sm={24}>
                <div className="modal_container_forfiltermenu">
                  <h4 className="flilter_five">
                    {modalType === "resolve"
                      ? "Resolving KPI"
                      : "Updating ODO Reading"}
                  </h4>
                </div>
                <hr />
              </Col>

              {modalType === "resolve" && (
                <Col xl={24} sm={24}>
                  <p>Give the reason or comment to resolve</p>
                </Col>
              )}

              {modalType === "udoUpdate" && (
                <Col xl={24} sm={24}>
                  <p>ODO Reading</p>
                </Col>
              )}

              <Col xl={24} sm={24}>
                <div className="container_for_uimodaltwo"> </div>
              </Col>
            </Row>
          </WrapperBox>
        }
        footer={[
          <WrapperBox key="footer">
            <div
              style={{
                display: "flex",
                flexDirection: "row",
                justifyContent: "flex-end",
                gap: "15px",
              }}
            >
              <ButtonFilled
                onClick={handleModalClose}
                className="cancel_btn_forpopup_two"
              >
                Cancel
              </ButtonFilled>
              <ButtonFilled onClick={editModuleupdate}>
                {modalType === "resolve" ? "Resolve" : "Update"}
              </ButtonFilled>
            </div>
          </WrapperBox>,
        ]}
      />
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="consingment_container">
              <div className="consingment_container_two">
                <ButtonOutlined onClick={handleClickme} className="Create_btn">
                  <LeftOutlined className="left_outlined_icon" />
                </ButtonOutlined>
                <p>Fuel Details - {details?.RegNo || details?.REGNO}</p>
              </div>

              <div className="consingment_container_two  consingment_container_formbresponsive">
                <Tooltip title={!updateAllowed ? "No permission" : ""}>
                  <ButtonOutlined className="Create_btn_edit">
                    <EditIcon
                      style={{
                        cursor: updateAllowed ? "pointer" : "not-allowed",
                      }}
                      onClick={(e) => {
                        if (!updateAllowed) return;
                        e.stopPropagation();
                        handleeditclick();
                      }}
                    />
                  </ButtonOutlined>
                </Tooltip>
                <Tooltip title={!deleteAllowed ? "No permission" : ""}>
                  <ButtonOutlined
                    style={{
                      cursor: deleteAllowed ? "pointer" : "not-allowed",
                    }}
                    className="Create_btn_edit"
                    onClick={() => {
                      if (!deleteAllowed) return;
                      handleDeleteClick();
                    }}
                  >
                    <DeleteIcon />
                  </ButtonOutlined>
                </Tooltip>
              </div>
            </div>
          </Col>
        </Row>
      </WrapperBox>
      <WrapperBox>
        <Row gutter={16}>
          <Col xs={24} xl={24}>
            <div className="container_for_consignorpage">
              <div className="consignor_code">
                <label>Vehicle</label>
                <p>{details?.RegNo || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Fuel Date</label>
                <p>
                  {moment(details?.FUELDATE).format("Do MMM YYYY; hh:mm A")}
                </p>
              </div>
              <div className="consignor_code">
                <label>Litres Fueled</label>
                <p>{details?.QTY || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Price Per Litre</label>
                <p>{details?.RATE || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Amount</label>
                <p>{details?.AMOUNT || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>ODO Reading</label>
                <p>{details?.ODOREADING || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Mileage</label>
                <p>{details?.MILAGE || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Station Name</label>
                <p>{details?.StationName || "-"}</p>
              </div>
              <div className="consignor_code">
                <label>Transporter</label>
                <p>{details?.SupName || "-"}</p>
              </div>
              {Array.isArray(CustomData) &&
                CustomData.length > 0 &&
                CustomData.map((field) => (
                  <div className="consignor_code" key={field.CFID}>
                    <label>{field.FIELDNAME}</label>
                    <p>{field.VALUE || "-"}</p>
                  </div>
                ))}
            </div>
          </Col>
        </Row>
      </WrapperBox>

      <WrapperBox>
        <Row gutter={16}>
          <Col xl={24} xs={24}>
            <div style={{ marginTop: "12px" }} className="tabsectionfor_table">
              <Tabs
                className="consignor_tab_container"
                onChange={handlechange}
                type="card"
                items={[
                  {
                    label: "Files",
                    key: "1",
                  },
                ]}
              />
              <div>
                {activekey === "1" && (
                  <div style={{ textAlign: "right" }}>
                    {/* <Tooltip title={!fUploadAllowed ? "No permission" : ""}> */}
                      <Upload
                        customRequest={({ file, onSuccess }) => {
                                                // Get current position
                      navigator.geolocation.getCurrentPosition(
                        (position) => {
                          const { latitude, longitude } = position.coords;
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            const base64Data = reader.result.split(",")[1];
                            onSuccess();

                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "FUEL",
                              refId: fuelId,
                              lat: String(latitude),
                              lng: String(longitude),
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                              BASE: base64Data,
                            };
                            handleFileUpload(payload);
                          };

                          reader.onerror = (error) => {
                            console.error("File read error:", error);
                          };
                        },
                        (error) => {
                          // If location access denied or failed, fallback to empty values
                          console.error("Geolocation error:", error);
                          const reader = new FileReader();
                          reader.readAsDataURL(file);

                          reader.onload = () => {
                            onSuccess();
                            const payload = {
                              title: file.name,
                              fileSize: file.size,
                              mimeType: 1,
                              crBy: userInfo?.UID,
                              attKey: "testKey",
                              refTab: "FUEL",
                              refId: fuelId,
                              lat: "",
                              lng: "",
                              crOn: new Date(),
                              fileName: file.name,
                              fileType: file.name.split(".").pop(),
                              file: reader.result,
                            };
                            handleFileUpload(payload);
                          };
                        }
                      );
                    }}
                        showUploadList={false}
                      >
                        <ButtonFilled
                          style={{
                            // cursor: fUploadAllowed ? "pointer" : "not-allowed",
                            cursor: "pointer"
                          }}
                          className="upload-style1"
                        >
                          + Add
                        </ButtonFilled>
                      </Upload>
                    {/* </Tooltip> */}
                  </div>
                )}
              </div>
            </div>
          </Col>
        </Row>

        {activekey === "1" && (
          <Spin spinning={loading}>
            <FilesTable filesList={filesList} getFileData={getFileData} />
          </Spin>
        )}
      </WrapperBox>

      {/* <ReusableDrawer
        title=""
        open={drawerOpen}
        setOpen={setDrawerOpen}
        onClose={handleClose}
        closable={false}
        footer={[
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              alignItems: "center",
              justifyContent: "flex-end",
              gap: "15px",
            }}
          >
            <Button
              key="cancel"
              className="cancel-btn"
              onClick={handleClose}
              style={{
                borderRadius: "26px",
                backgroundColor: "#E8FFEC",
                color: "#2C963D",
                borderColor: "#E8FFEC",
                width: "118px",
                height: "38px",
              }}
            >
              Cancel
            </Button>
            <ButtonFilled
              key="create"
              type="primary"
              onClick={handleSubmitForm}
            >
              Create
            </ButtonFilled>
          </div>,
        ]}
      >
        <WrapperBox>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <div className="Creating_Consignor">
                <p>Creating Consignor</p>

                <span>
                  <CloseOutlined onClick={handleClose} />
                </span>
              </div>
            </Col>
          </Row>
          <Row gutter={16}>
            <Col xl={24} xs={24}>
              <GridBuilder
                formStructureJson={AddEditFormm}
                handleChange={handleChange}
                formSubmit={handleSubmitForm}
                initialValues={formData}
                form={form}
              />
            </Col>
          </Row>
        </WrapperBox>
      </ReusableDrawer> */}
    </>
  );
};

export default FuelDetails;
